// Phase 4.3 — Online Billing screen, migrated to shadcn/Tailwind.
//
// UI only: the MUI Table, the ApparelSubmenu toolbar (payment-status + order-
// status filters + search) and the antd Drawer status editor are replaced by the
// shared DataTable (OnlineBillingTable) with the two filter Selects in its
// toolbar slot, a PageHeader, and a Sheet (OnlineOrderStatusSheet). Every
// dispatch / useSelector / payload is unchanged — the handlers below are the
// legacy ones (getOnlineOrderAction / updateOnlineOrderAction). Order + payment
// status render as StatusBadges.
import { useDispatch, useSelector } from "react-redux";
import { getOnlineOrderAction, updateOnlineOrderAction } from "../Store/actions/apparelAction";
import { useEffect, useState } from "react";
import { deepCopyFunction } from "../Utils/helpers";
import { useNavigate } from "react-router-dom";
import AppConstant from "../Globals/AppConstants";
import ApparelMenu from "./SubComponents/apparelMenu";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "ui/select";
import OnlineBillingTable from "./orders/OnlineBillingTable";
import OnlineOrderStatusSheet from "./orders/OnlineOrderStatusSheet";

const searchtemp: any = {
    searchText: "",
    filterStatus: "0",
    offset: 0,
    limit: 10,
    page: 1,
    paymentStatus: "1"
};

const OnlineBilling = () => {
    const [filterData, setFilterData] = useState<any>(deepCopyFunction(searchtemp));
    const [openDrawer, setOpenDrawer] = useState(false);
    const [onlineStatus, setOnlineStatus] = useState<any>(null);
    const [drawerOrderId, setDrawerOrderId] = useState<any>(null);
    const [updateOnlineOrderLoad, setUpdateOnlineOrderLoad] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const apparelReducer = useSelector((state: any) => state.ApparelReducerState);

    const { getOnlineOrderData, getOnlineOrderLoad, updateOnlineOrderActionLoad } = apparelReducer;
    const getOnlineOrderList = getOnlineOrderData?.orderData
    const getOnlineOrderPage = getOnlineOrderData?.page

    const handlePagination = (page: any, offset: any) => {
        setFilterData({ ...filterData, page: page, offset: offset })
    }

    // DataTable gives a 1-based page; translate to the legacy offset math.
    const onPageChange = (nextPage: number) => {
        let offset = ((nextPage * 10) - 10 === 0) ? 0 : (nextPage * 10) - 10;
        handlePagination(nextPage, offset);
    }

    const getsearchTextdataList = (searchText: any) => {
        setFilterData({ ...filterData, searchText: searchText, offset: 0, page: 1 })
    }

    const getFilterStatusdataList = (filterStatus: any) => {
        setFilterData({ ...filterData, filterStatus: filterStatus, offset: 0, page: 1 })
    }

    const getPaymentStatus = (paymentStatus: any) => {
        setFilterData({ ...filterData, paymentStatus: paymentStatus, offset: 0, page: 1 })
    }

    const getOnlineOrderApi = () => {
        let payload = {
            searchText: filterData?.searchText,
            sort: Number(filterData?.filterStatus),
            paymentStatus: Number(filterData?.paymentStatus),
            paging: {
                limit: filterData?.limit,
                offset: filterData?.offset
            }
        }
        dispatch(getOnlineOrderAction(payload))
    }

    const updateOnlineOrderApi = () => {
        let payload = {
            orderId: drawerOrderId,
            orderStatus: onlineStatus
        }
        dispatch(updateOnlineOrderAction(payload))
        setUpdateOnlineOrderLoad(true)
    }

    const onlineOrderIdAndDrawer = (data: any) => {
        setOnlineStatus(data?.orderStatus)
        setDrawerOrderId(data?.orderId)
        setOpenDrawer(true)
    }

    useEffect(() => {
        if (filterData)
            getOnlineOrderApi()
    }, [filterData])

    const onCloseAction = () => {
        setOpenDrawer(false);
        getOnlineOrderApi()
    }

    useEffect(() => {
        if (!updateOnlineOrderActionLoad && updateOnlineOrderLoad) {
            onCloseAction()
            setUpdateOnlineOrderLoad(false)
            setOpenDrawer(false);
        }
    }, [updateOnlineOrderLoad, updateOnlineOrderActionLoad])

    const filterToolbar = (
        <div className="flex items-center gap-2">
            <Select value={filterData?.paymentStatus} onValueChange={(v) => getPaymentStatus(v)}>
                <SelectTrigger className="w-[180px]"><SelectValue placeholder="Status" /></SelectTrigger>
                <SelectContent>
                    <SelectItem value="1">{AppConstant?.PAYMENT_SUCCESS}</SelectItem>
                    <SelectItem value="2">{AppConstant?.PAYMENT_FAILURE}</SelectItem>
                </SelectContent>
            </Select>
            {filterData?.paymentStatus == 1 && (
                <Select value={filterData?.filterStatus} onValueChange={(v) => getFilterStatusdataList(v)}>
                    <SelectTrigger className="w-[180px]"><SelectValue placeholder="Status" /></SelectTrigger>
                    <SelectContent>
                        <SelectItem value="0">All Orders</SelectItem>
                        <SelectItem value="1">{AppConstant?.NEWORDERS}</SelectItem>
                        <SelectItem value="2">{AppConstant?.INTRANSIT}</SelectItem>
                        <SelectItem value="3">{AppConstant?.DELIVERED}</SelectItem>
                        <SelectItem value="4">{AppConstant?.CANCELLED}</SelectItem>
                        <SelectItem value="5">{AppConstant?.returned}</SelectItem>
                    </SelectContent>
                </Select>
            )}
        </div>
    );

    return (
        <div className="mz h-full overflow-y-auto px-6 py-4">
            <ApparelMenu selectedKey="13" />
            <OnlineBillingTable
                data={getOnlineOrderList}
                loading={getOnlineOrderLoad}
                onEdit={onlineOrderIdAndDrawer}
                searchValue={filterData?.searchText}
                onSearch={getsearchTextdataList}
                searchPlaceholder={"Search By Order ID/Customer Name"}
                toolbar={filterToolbar}
                title="Online Billings"
                pagination={{
                    page: getOnlineOrderPage?.currentPage || 1,
                    total: getOnlineOrderPage?.totalCount || 0,
                    onChange: onPageChange,
                }}
            />
            <OnlineOrderStatusSheet
                open={openDrawer}
                onClose={() => setOpenDrawer(false)}
                status={onlineStatus}
                saving={updateOnlineOrderActionLoad}
                onStatusChange={(s: number) => setOnlineStatus(s)}
                onSave={updateOnlineOrderApi}
            />
        </div>
    )
}

export default OnlineBilling;
